/**
 * giustiziasociale.net — entry JS
 * Funzioni: theme toggle (dark/light persistente), newsletter form (no-reload),
 * search modal placeholder.
 */

(function () {
  "use strict";

  const STORAGE_KEY = "gs:theme";

  // ---- Theme toggle ----
  function getCurrentTheme() {
    return document.documentElement.getAttribute("data-theme") || "dark";
  }

  function applyTheme(theme) {
    const root = document.documentElement;
    root.classList.remove("theme-dark", "theme-light");
    root.classList.add("theme-" + theme);
    root.setAttribute("data-theme", theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
      /* ignore */
    }

    document.querySelectorAll("[data-theme-toggle]").forEach(function (btn) {
      btn.setAttribute("aria-pressed", theme === "light" ? "true" : "false");
      const dark = btn.querySelector(".theme-icon-dark");
      const light = btn.querySelector(".theme-icon-light");
      if (dark && light) {
        dark.classList.toggle("hidden", theme === "light");
        light.classList.toggle("hidden", theme !== "light");
      }
    });
  }

  document.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-theme-toggle]");
    if (!btn) return;
    const next = getCurrentTheme() === "light" ? "dark" : "light";
    applyTheme(next);
  });

  // Sync icone con tema corrente al boot
  document.addEventListener("DOMContentLoaded", function () {
    applyTheme(getCurrentTheme());
  });

  // ---- Newsletter form ----
  document.addEventListener("submit", async function (e) {
    const form = e.target.closest("[data-newsletter-form]");
    if (!form) return;
    e.preventDefault();

    const feedback = form.querySelector("[data-newsletter-feedback]");
    const data = new FormData(form);

    // Honeypot
    if (data.get("website")) {
      return; // bot silently dropped
    }

    if (feedback) feedback.textContent = "Invio in corso…";

    try {
      const res = await fetch(form.action, {
        method: "POST",
        body: data,
        headers: { "X-Requested-With": "fetch" },
        credentials: "same-origin",
      });

      if (res.ok) {
        if (feedback)
          feedback.textContent = "Iscrizione ricevuta. Controlla la tua email.";
        form.reset();
      } else {
        if (feedback) feedback.textContent = "Errore: riprova più tardi.";
      }
    } catch (err) {
      if (feedback) feedback.textContent = "Errore di rete: riprova.";
    }
  });

  // ---- Search modal placeholder ----
  document.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-search-toggle]");
    if (!btn) return;
    // TODO: aprire modale ricerca (Sezione 6.x)
  });

  // ---- Mobile menu drawer ----
  function setMobileMenu(open) {
    const panel = document.querySelector("[data-mobile-menu]");
    const toggle = document.querySelector("[data-mobile-menu-toggle]");
    if (!panel || !toggle) return;
    panel.hidden = !open;
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    toggle.setAttribute(
      "aria-label",
      open ? "Chiudi menu di navigazione" : "Apri menu di navigazione",
    );
    const iconOpen = toggle.querySelector(".mobile-menu-icon-open");
    const iconClose = toggle.querySelector(".mobile-menu-icon-close");
    if (iconOpen && iconClose) {
      iconOpen.classList.toggle("hidden", open);
      iconClose.classList.toggle("hidden", !open);
    }
    document.body.style.overflow = open ? "hidden" : "";
  }

  document.addEventListener("click", function (e) {
    const toggle = e.target.closest("[data-mobile-menu-toggle]");
    if (toggle) {
      const isOpen = toggle.getAttribute("aria-expanded") === "true";
      setMobileMenu(!isOpen);
      return;
    }
    // Chiudi se click su un link interno al drawer
    const linkInMenu = e.target.closest(
      "[data-mobile-menu] a, [data-mobile-menu] button[type=submit]",
    );
    if (linkInMenu) {
      setMobileMenu(false);
    }
  });

  // ESC chiude
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    const panel = document.querySelector("[data-mobile-menu]");
    if (panel && !panel.hidden) setMobileMenu(false);
  });

  // ---- Tessera editor modal ----
  const tesseraModal = document.querySelector("[data-tessera-modal]");
  if (tesseraModal) {
    const form = tesseraModal.querySelector("[data-tessera-modal-form]");
    const status = tesseraModal.querySelector("[data-tessera-modal-status]");
    const summary = tesseraModal.querySelector("[data-tessera-summary]");
    const title = tesseraModal.querySelector("[data-tessera-modal-title]");
    const fields = ["sede", "tipo_tessera", "nome", "cognome", "data_nascita", "cf", "citta_nascita", "stato", "telefono", "email", "indirizzo", "citta_residenza", "provincia", "cap", "stato_residenza", "consenso_privacy"];

    function closeTesseraModal() {
      tesseraModal.close();
      document.body.style.overflow = "";
    }

    function openTesseraModal(row) {
      const url = row && row.getAttribute("data-tessera-edit-url");
      if (!url) return;
      status.className = "hidden";
      fetch(url, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Impossibile caricare la tessera.");
          return response.json();
        })
        .then(function (data) {
          title.textContent = "Modifica tessera #" + data.tesseraNum;
          form.action = "/dashboard/tessere/" + data.id;
          fields.forEach(function (name) {
            const input = form.elements[name];
            if (!input) return;
            if (name === "consenso_privacy") input.checked = Boolean(data.fields[name]);
            else input.value = data.fields[name] || "";
          });
          summary.textContent = "ID: " + data.id + " · Numero: " + data.tesseraNum + " · Anno: " + data.anno + " · Stato: " + data.statusLabel + " · Importo: €" + data.amountEur + " " + data.currency;
          tesseraModal.showModal();
          document.body.style.overflow = "hidden";
        })
        .catch(function (error) {
          status.textContent = error.message;
          status.className = "rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm";
        });
    }

    document.addEventListener("click", function (e) {
      const row = e.target.closest("[data-tessera-edit-url]");
      if (!row) return;
      if (e.target.closest("a, button, input, select, form")) {
        const editButton = e.target.closest("[data-tessera-edit]");
        if (editButton) openTesseraModal(editButton.closest("[data-tessera-edit-url]"));
        return;
      }
      openTesseraModal(row);
    });

    document.addEventListener("keydown", function (e) {
      const row = e.target.closest("[data-tessera-edit-url]");
      if (row && (e.key === "Enter" || e.key === " ")) {
        e.preventDefault();
        openTesseraModal(row);
      }
    });
    tesseraModal.addEventListener("click", function (e) {
      if (e.target === tesseraModal) closeTesseraModal();
    });
    tesseraModal.addEventListener("cancel", function () {
      document.body.style.overflow = "";
    });
    tesseraModal.querySelectorAll("[data-tessera-close]").forEach(function (button) {
      button.addEventListener("click", closeTesseraModal);
    });
  }

  // Resize: se passa a desktop chiudi e ripristina scroll
  let resizeTimer = null;
  window.addEventListener("resize", function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (window.matchMedia("(min-width: 768px)").matches) {
        setMobileMenu(false);
      }
    }, 100);
  });
})();

/* ================================================================
 * Toggle visibilità password (occhio mostra/nascondi)
 * Funziona su qualsiasi <input type="password"> con accanto un
 * <button data-password-toggle> dentro lo stesso wrapper relative.
 * ============================================================== */
(function () {
  "use strict";
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-password-toggle]");
    if (!btn) return;
    var wrap = btn.parentElement;
    if (!wrap) return;
    var input = wrap.querySelector("input[type=password], input[type=text]");
    if (!input) return;
    var isPwd = input.type === "password";
    input.type = isPwd ? "text" : "password";
    btn.setAttribute(
      "aria-label",
      isPwd ? "Nascondi password" : "Mostra password",
    );
    var open = btn.querySelector(".eye-open");
    var closed = btn.querySelector(".eye-closed");
    if (open) open.classList.toggle("hidden", isPwd);
    if (closed) closed.classList.toggle("hidden", !isPwd);
  });
})();
